import { useEffect, useState } from "react";
import { supabase } from "../lib/supabaseClient";
import type { Country } from "../lib/types";

/** Static reference data (196 rows) - fetched once, no realtime needed. */
export function useCountries(): { countries: Map<number, Country>; loading: boolean } {
  const [countries, setCountries] = useState<Map<number, Country>>(new Map());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    (async () => {
      const { data, error } = await supabase.from("countries").select("*");
      if (!active) return;
      if (error) {
        console.error("failed to load countries", error);
      } else if (data) {
        setCountries(new Map((data as Country[]).map((c) => [c.iso_numeric, c])));
      }
      setLoading(false);
    })();
    return () => {
      active = false;
    };
  }, []);

  return { countries, loading };
}

export function countryDisplayName(country: Country | undefined, fallback: string): string {
  return country?.name_en || country?.name_sl || fallback;
}
